export class ADALandmarks {
    static Banner = "banner";
    static Complementary = "complementary";
    static ContentInfo = "contentinfo";
    static Form = "form";
    static Main = "main";
    static Navigation = "navigation";
    static Search = "search";
    static Application = "application";
}

export class ADAWidgitRoles {
    static Button = "button";
    static Link = "link";
}

export class ADAARIARoles {
    static Heading = "heading";
    static ListItem = "listitem";
    static List = "list";
    static Region = "region";
    static Group = "group";
    static Feed = "feed";
	static Navigation = "navigation";
    static Application = "application";
    static Presentation = "presentation";
    static Article = "article";
    static None = "none";
}